
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-mathematics-mains-test-series",
      function () {
        return require("private-next-pages/upsc-mathematics-mains-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-mathematics-mains-test-series"])
      });
    }
  